// @flow
import React, { Component } from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import { FormattedMessage } from 'react-intl';
import Input from '@liveauctioneers/caterwaul-components/lib/Input/Input';
import isEqual from 'react-fast-compare';
import { email as isValidEmail } from '../../../utils/validation';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import styles from './SignUpEmail.module.scss';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

type Props = {
    bidderExists: boolean,
    error: string,
    setEmail: Function,
    submitCreateAccount: Function,
    submitted: boolean,
};

type State = {
    agree: boolean,
    email: string,
    emailValid: boolean,
};

export default class SignUpEmail extends Component<Props, State> {
    state = {
        agree: false,
        email: '',
        emailValid: true,
    };

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    onValueChange = (event: SyntheticInputEvent<>) => {
        const newState = {};
        newState[event.target.id] = event.target.value;
        this.setState(newState);
    };

    onAgreeValueChange = (event: SyntheticInputEvent<>) => {
        const newState = { agree: event.target.checked };
        this.setState(newState);
    };

    onSignUp = () => {
        const email = this.state.email.trim();
        const emailValid = isValidEmail(email);
        const agree = this.state.agree;
        this.setState({ emailValid });
        if (emailValid) {
            this.props.setEmail(email);
            this.props.submitCreateAccount(email, agree);
        }
    };

    render() {
        const { bidderExists, error, submitted } = this.props;

        const { agree, email, emailValid } = this.state;

        let errorMessage = '';
        const errorOnPage = !emailValid || (error && !bidderExists);

        const tosLink = (
            <Link to="/termsandconditions" target="_blank" rel="noopener">
                <FormattedMessage id="signUpModal.termsLink" />
            </Link>
        );
        const privacyLink = (
            <Link to="/privacy" target="_blank" rel="noopener">
                <FormattedMessage id="signUpModal.privacyLink" />
            </Link>
        );
        const cookieLink = (
            <Link to="/cookie-policy" target="_blank" rel="noopener">
                <FormattedMessage id="signUpModal.cookieLink" />
            </Link>
        );

        if (!emailValid) {
            errorMessage = <FormattedMessage id="signUpModal.invalidEmail" />;
        } else if (error && !bidderExists) {
            errorMessage = <FormattedMessage id="signUpModal.error" />; // we could show the error
        }
        return (
            <div className={styles.body}>
                <Input
                    autoCapitalize={false}
                    autoComplete={false}
                    autoCorrect={false}
                    autoFocus
                    errorMessage={errorMessage}
                    id="email"
                    label={<FormattedMessage id="signUpModal.username" />}
                    onChange={this.onValueChange}
                    valid={!errorOnPage}
                    e2e="joinModalEmail"
                />
                <Checkbox className={styles['check-box']} checked={agree} onChange={this.onAgreeValueChange}>
                    <FormattedMessage id="signUpModal.acceptText" values={{ cookieLink, privacyLink, tosLink }} />
                </Checkbox>
                <div className={styles.links}>
                    <Button
                        className={styles.submit}
                        primary
                        red
                        disabled={submitted || !email || !agree}
                        onClick={this.onSignUp}
                        e2e="joinModalStartNow"
                    >
                        {!submitted ? <FormattedMessage id="signUpModal.submit" /> : <Throbber colorWhite />}
                    </Button>
                </div>
            </div>
        );
    }
}
